// extracted by mini-css-extract-plugin
module.exports = {"hint":"styles_hint__2DpVu","hintItem":"styles_hintItem__1h0xm","bold":"styles_bold__3qh2B","fakeCreateOption":"styles_fakeCreateOption__1TjFy"};